import { PurchaseDeviceType } from './constants';

export const PREFIX_TRACKING_ID = 'purchase-device';

export const getPurchaseDeviceActionTrackingId = ({
  device,
  source,
  elementSource = 'button',
}: {
  device: PurchaseDeviceType;
  source?: string;
  elementSource?: string;
}) => {
  return [PREFIX_TRACKING_ID, source, device, elementSource].filter((str) => !!str).join(':');
};
